import {HttpErrorResponse} from '@angular/common/http';
import {Component, Inject, OnDestroy} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TargetService, TtdCategory, TtdCategoryRequest} from '../../../target/target.service';
import {SubscriptionHandler} from '../../../utils/subscription-handler';
import {CategoryState} from '../ttd-category-config.component';

@Component({
  selector: 'app-ttd-category-create',
  templateUrl: './ttd-category-create.component.html',
  styleUrls: ['./ttd-category-create.component.scss']
})
export class TtdCategoryCreateComponent implements OnDestroy {
  static CATEGORY_PATTERN = /^[\w\s_-]+$/;
  selectedParentId = new FormControl('', Validators.required);
  categoryName = new FormControl('', [Validators.required, Validators.pattern(TtdCategoryCreateComponent.CATEGORY_PATTERN)]);
  errorMessage!: string;
  categories: TtdCategory[];
  isRequesting = false;

  private subscriptionHandler = new SubscriptionHandler();
  activeCategoryState: CategoryState;

  constructor(@Inject(MAT_DIALOG_DATA) data: { categories: TtdCategory[], activeCategoryState: CategoryState },
              private targetService: TargetService,
              private dialogRef: MatDialogRef<TtdCategoryCreateComponent>) {
    this.categories = data.categories;
    this.activeCategoryState = data.activeCategoryState;
  }

  ngOnDestroy() {
    this.subscriptionHandler.unsubscribe();
  }

  reset() {
    this.selectedParentId.reset();
    this.categoryName.reset();
  }

  create() {
    this.isRequesting = true;
    const ttdCategory: TtdCategoryRequest = {
      displayName: this.categoryName.value,
      parentId: this.selectedParentId.value,
      origin: CategoryState[this.activeCategoryState]
    };
    this.subscriptionHandler.subscription = this.targetService.createTtdCategory(ttdCategory).subscribe({
      next: () => {
        this.isRequesting = false;
        this.dialogRef.close();
      },
      error: (error: HttpErrorResponse) => {
        this.isRequesting = false;
        this.errorMessage = error.error.message;
      }
    });
  }

  getTtdCategoryTitle() {
    return this.activeCategoryState === CategoryState.TTD ? 'The Trade Desk' : 'The Trade Desk: Data Alliance';
  }
}
